import _ from 'lodash'

import config from '@/config'
import store from '@/store'

export function getRevLink(rev) {
  const organizationId = store.access.getOrganizationId()

  if (rev.entityType === 'improvementIdea')
    return `${config.web}/rev/${organizationId}/${rev.id}`
  return `${config.web}/${_.kebabCase(rev.entityType)}/${organizationId}/${
    rev.id
  }`
}

export function getRevStatus(rev) {
  return rev.status || rev.revCondition
}

export function isRevValidated(rev) {
  return Boolean(
    rev.metadata?.validations?.implementation?.isValidated ||
      rev.metadata?.validations__implementation__isValidated ||
      rev?.validations?.implementation?.isValidated ||
      rev?.validation?.implementation ||
      rev?.validations__implementation__isValidated
  )
}

export function isFinanciallyValidated(rev) {
  return (
    rev?.metadata?.validations?.financial?.isValidated ??
    rev?.metadata?.validations__financial__isValidated ??
    rev?.validations?.financial?.isValidated ??
    rev?.validation?.financial ??
    rev?.validations__financial__isValidated ??
    false
  )
}

export function isHighlighted(rev) {
  return (
    rev?.isHighlighted ??
    rev?.validation?.highlight ??
    rev?.metadata?.isHighlighted ??
    rev?.metadata?.highlight__isHighlighted ??
    false
  )
}

export function getRevCurrency(rev) {
  return (
    rev?.financialMetadata?.revCurrency ??
    rev?.financialMetadata?.currency ??
    rev?.currencyMetadata?.currentCurrency ??
    ''
  )
}

export default {
  getRevStatus,
  isRevValidated,
  isFinanciallyValidated,
  isHighlighted,
  getRevCurrency,
  getRevLink,
}
